import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';
import { setUserPreference } from '../../helpers/user-preferences';

const pageButtonRenderer = ({ page, active, onPageChange }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  const activeStyle = {};
  activeStyle.fontSize = '10px';
  activeStyle.padding = '6px 8px';
  if (active) {
    activeStyle.border = '1.5px solid #4db5ff';
    activeStyle.color = '#6e6e6e';
    activeStyle.outline = 'none';
  } else {
    activeStyle.backgroundColor = 'white';
    activeStyle.color = '#6e6e6e';
  }
  if (typeof page === 'string') {
    activeStyle.fontSize = '12px';
    activeStyle.backgroundColor = 'white';
    activeStyle.color = '#6e6e6e';
    activeStyle.outline = 'none';
  }
  return (
    <li key={`page-${page}`} className='page-item'>
      <a href='/#' onClick={handleClick} style={activeStyle}>
        {page}
      </a>
    </li>
  );
};

const getPagingOpts = (pageSize) => ({
  alwaysShowAllBtns: true,
  withFirstAndLast: false,
  hideSizePerPage: true,
  prePageText: '<',
  nextPageText: '>',
  hidePageListOnlyOnePage: true,
  sizePerPageList: [
    {
      text: pageSize.toString(),
      value: pageSize,
    },
  ],
  pageButtonRenderer,
});

const EnergyTracerTable = ({
  keyField = 'id',
  enableFilter = true,
  filter = filterFactory(),
  filterPosition = 'top',
  enablePaging = false,
  pageSize = 10,
  enableScroll,
  ...props
}) => (
  <BootstrapTable
    {...props}
    bootstrap4
    condensed
    hover
    bordered={false}
    wrapperClasses={classNames({
      'et-table-wrapper': enableScroll,
    })}
    headerWrapperClasses={classNames({
      'et-table-header': enableScroll,
    })}
    headerClasses='bg-light text-dark'
    filter={enableFilter ? filter : undefined}
    filterPosition={enableFilter ? filterPosition : undefined}
    keyField={keyField}
    pagination={
      enablePaging ? paginationFactory(getPagingOpts(pageSize)) : undefined
    }
  />
);

export const AddEntityFilterHeader = (props) => {
  const {
    onFilter,
    filterText,
    buttonText,
    onButtonClick,
    disabled,
    showButton,
  } = props;
  return (
    <div
      style={{
        width: '100%',
        marginTop: '2px',
      }}
    >
      <Form.Control
        style={{
          display: 'inline',
          width: '55%',
          fontSize: '14px',
          textAlign: 'center',
        }}
        placeholder={filterText}
        onChange={(e) => onFilter(e.target.value)}
        data-id='table_filter'
      />
      {showButton && (
        <Button
          variant='success'
          className='ml-3'
          style={{ display: 'inline' }}
          onClick={() => onButtonClick()}
          disabled={disabled}
          data-id='table_btn'
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export const AddEntityFilterHeaderPreference = (props) => {
  const {
    onFilter,
    filterText,
    buttonText,
    onButtonClick,
    disabled,
    showButton,
    defaultValue,
  } = props;

  const [key, setKey] = useState(0);

  useEffect(() => {
    if (defaultValue && key === 0) {
      onFilter(defaultValue);
      setKey(key + 1);
    }
  }, [defaultValue, key, onFilter]);

  const clearFilter = () => {
    setUserPreference('last_filtered_org', '');
    onFilter('');
  };

  return (
    <div
      style={{
        width: '100%',
        marginTop: '2px',
      }}
    >
      <Form.Control
        style={{
          display: 'inline',
          width: '55%',
          fontSize: '14px',
          textAlign: 'center',
        }}
        placeholder={filterText}
        value={defaultValue}
        onChange={(e) => onFilter(e.target.value)}
        data-id='table_filter'
      />
      {defaultValue && (
        <Button
          variant='outline-danger'
          style={{
            position: 'relative',
            left: '-35px',
            right: '-2px',
            padding: '0px',
            borderWidth: '0px',
            borderRadius: '50%',
            height: '28px',
            width: '28px',
          }}
        >
          <FontAwesomeIcon
            style={{ fontSize: '18px', lineHeight: 'inherit' }}
            icon={faTimesCircle}
            onClick={() => clearFilter()}
          />
        </Button>
      )}
      {showButton && (
        <Button
          variant='success'
          className='ml-3'
          style={{ display: 'inline' }}
          onClick={() => onButtonClick()}
          disabled={disabled}
          data-id='table_btn'
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

EnergyTracerTable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  enablePaging: PropTypes.bool,
  pageSize: PropTypes.number,
  hover: PropTypes.bool,
  keyField: PropTypes.string,
  selectRow: PropTypes.object,
  disabled: PropTypes.bool,
  enableScroll: PropTypes.bool,
};

AddEntityFilterHeader.defaultProps = {
  showButton: false,
  enableScroll: false,
};

AddEntityFilterHeaderPreference.defaultProps = {
  showButton: false,
  enableScroll: false,
  defaultValue: '',
};

export default EnergyTracerTable;
